export default __webpack_public_path__ + "static/media/speakers__don-melton.3df591c4.jpg";